import { takeLatest, call, put } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { sendFile, fileList, sendNotificationUpload } from 'api';

import * as actions from './actions';

function* sendHandl(action) {
  const { payload: { callback, file } } = action;
  const step = 100;
  let milliseconds = 0;
  const interval = setInterval(() => {
    milliseconds += step;
  }, step);

  try {
    yield put(actions.fileUploading());
    const result = yield call(sendFile, file);

    if (milliseconds <= 2000) {
      yield delay(2000 - milliseconds);
    }

    yield put(actions.fileUploaded());
    clearInterval(interval);

    if (callback) {
      callback(result);
    }
  } catch (err) {
    if (callback) {
      callback(err);
    }
  }
}

function* getListHandl(action) {
  const { payload: { callback } } = action;

  try {
    const result = yield call(fileList);
    yield put(actions.saveFileList(result.data));
    if (callback) {
      callback(result.data ? result.data.length : 0);
    }
  } catch (err) {
    console.log(err);
  }
}

function* sendNotificationHandl(action) {
  const { payload: { cb } } = action;

  try {
    yield call(sendNotificationUpload);
    if (cb) {
      cb();
    }
  } catch (err) {
    console.log(err);
  }
}

export default function* () {
  yield takeLatest(
    actions.FILE_SEND,
    sendHandl
  );
  yield takeLatest(
    actions.FILE_LIST,
    getListHandl
  );
  yield takeLatest(
    actions.FILE_NOTIFICATON,
    sendNotificationHandl
  );
}



// WEBPACK FOOTER //
// ./src/pages/Upload/saga.js